const marqueeGroups = document.querySelectorAll(".marquee-group");

if (marqueeGroups) {
  // Pause the animation on hover for both marquee groups
  marqueeGroups.forEach((group) => {
    group.addEventListener("mouseenter", function () {
      const allMarqueeGroups = document.querySelectorAll(".marquee-group");
      allMarqueeGroups.forEach((marqueeGroup) => {
        marqueeGroup.style.animationPlayState = "paused";
      });
    });
  });

  // Resume the animation on mouse leave for both marquee groups
  marqueeGroups.forEach((group) => {
    group.addEventListener("mouseleave", function () {
      const allMarqueeGroups = document.querySelectorAll(".marquee-group");
      allMarqueeGroups.forEach((marqueeGroup) => {
        marqueeGroup.style.animationPlayState = "running";
      });
    });
  });
}
